




import Vue from 'vue';
import OfficialDocumentMail from '@/components/official-documents/official-document-mail.component.vue';

export default Vue.extend({
  components: {
    'official-document-mail': OfficialDocumentMail,
  },
});
